import type { BTLeaf } from "../types";
import type { LeafContext, TickResult } from "./context";
import { tickCloseGripper, tickOpenGripper } from "./gripper";
import {
  tickGoToKeyframe,
  tickMoveEeByOffset,
  tickMoveEeToXyz,
  tickRunTrainedModel,
  tickServoPickPlace,
} from "./motion";
import { tickRandomizeObjectPose, tickResetToBaseline, tickSetObjectPose, tickWait } from "./scene";
import { tickMarkFailure, tickMarkSuccess } from "./episode";
import {
  tickConditionEeNear,
  tickConditionObjectGrasped,
  tickConditionObjectNear,
  tickConditionTimeElapsed,
} from "./conditions";

export type { LeafContext, LeafMemory, TickResult } from "./context";

export function dispatchLeaf(ctx: LeafContext, node: BTLeaf): TickResult {
  switch (node.kind) {
    case "openGripper":
      return tickOpenGripper(ctx, node);
    case "closeGripper":
      return tickCloseGripper(ctx, node);

    case "moveEeToXyz":
      return tickMoveEeToXyz(ctx, node);
    case "moveEeByOffset":
      return tickMoveEeByOffset(ctx, node);
    case "runTrainedModel":
      return tickRunTrainedModel(ctx, node);
    case "goToKeyframe":
      return tickGoToKeyframe(ctx, node);
    case "servoPickPlace":
      return tickServoPickPlace(ctx, node);

    case "randomizeObjectPose":
      return tickRandomizeObjectPose(ctx, node);
    case "setObjectPose":
      return tickSetObjectPose(ctx, node);
    case "resetToBaseline":
      return tickResetToBaseline(ctx, node);
    case "wait":
      return tickWait(ctx, node);

    case "markSuccess":
      return tickMarkSuccess(ctx, node);
    case "markFailure":
      return tickMarkFailure(ctx, node);

    case "conditionTimeElapsed":
      return tickConditionTimeElapsed(ctx, node);
    case "conditionObjectGrasped":
      return tickConditionObjectGrasped(ctx, node);
    case "conditionObjectNear":
      return tickConditionObjectNear(ctx, node);
    case "conditionEeNear":
      return tickConditionEeNear(ctx, node);

    default: {
      const _never: never = node;
      void _never;
      return "failure";
    }
  }
}
